var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelephone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_720_2175)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.66296 1.01064C2.87293 0.800988 3.12505 0.638352 3.40263 0.53351C3.68021 0.428668 3.9769 0.384015 4.27304 0.402509C4.56918 0.421004 4.85801 0.502224 5.12039 0.640787C5.38277 0.779351 5.6127 0.972093 5.79496 1.20624L7.94896 3.97344C8.34376 4.48104 8.48296 5.14224 8.32696 5.76624L7.67056 8.39424C7.63662 8.53036 7.63845 8.67294 7.67588 8.80813C7.7133 8.94333 7.78505 9.06656 7.88416 9.16584L10.8326 12.1142C10.932 12.2135 11.0554 12.2854 11.1908 12.3228C11.3262 12.3603 11.4691 12.362 11.6054 12.3278L14.2322 11.6714C14.5401 11.5944 14.8615 11.5885 15.1721 11.654C15.4827 11.7194 15.7743 11.8547 16.025 12.0494L18.7922 14.2022C19.787 14.9762 19.8782 16.4462 18.9878 17.3354L17.747 18.5762C16.859 19.4642 15.5318 19.8542 14.2946 19.4186C11.128 18.3045 8.25288 16.4916 5.88256 14.1146C3.5057 11.7447 1.69289 8.86999 0.578556 5.70384C0.144156 4.46784 0.534156 3.13944 1.42216 2.25144L2.66296 1.01064Z",
    fill: "#F08371"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_720_2175"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.2,
    height: 19.2,
    fill: "white",
    transform: "translate(0.400391 0.398438)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelephone);
export default __webpack_public_path__ + "static/media/telephone.c933fd850588c662df643ae50fbc1876.svg";
export { ForwardRef as ReactComponent };